import { render, staticRenderFns } from "./resultados.vue?vue&type=template&id=380bd38c"
import script from "./resultados.ts?vue&type=script&lang=js&external"
export * from "./resultados.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('380bd38c')) {
      api.createRecord('380bd38c', component.options)
    } else {
      api.reload('380bd38c', component.options)
    }
    module.hot.accept("./resultados.vue?vue&type=template&id=380bd38c", function () {
      api.rerender('380bd38c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/fichaTecnica/resultados.vue"
export default component.exports